import { AnalyticsEvents, EventConfig } from 'app/shared/u21-ui/analytics';
import { U21SubsectionProps } from 'app/shared/u21-ui/components';

export const getSectionName = (props: U21SubsectionProps): string => {
  const { 'aria-label': ariaLabel, title } = props;
  if (ariaLabel) {
    return ariaLabel;
  }
  if (typeof title === 'string') {
    return title;
  }
  return '';
};

export const expand: EventConfig = {
  name: 'Subsection Expanded',
  createPayload: (props: U21SubsectionProps) => {
    const name = getSectionName(props);
    if (!name) {
      return null;
    }
    return { name };
  },
};

export const collapse: EventConfig = {
  name: 'Subsection Collapsed',
  createPayload: (props: U21SubsectionProps) => {
    const name = getSectionName(props);
    if (!name) {
      return null;
    }
    return { name };
  },
};

export const u21SubSectionEvents = {
  [AnalyticsEvents.U21SUBSECTION_ON_EXPAND]: expand,
  [AnalyticsEvents.U21SUBSECTION_ON_COLLAPSE]: collapse,
};
